export default __webpack_public_path__ + "static/media/ally_s1.94c37c16.png";